// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consent-form {
  max-width: 700px;
  margin: 0 auto;
}

.consent-header {
  text-align: center;
  margin-bottom: 32px;
}

.consent-header h2 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 28px;
  font-weight: 700;
}

.consent-header p {
  color: #666;
  font-size: 15px;
  margin: 0;
}

.consent-form-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.consent-item {
  padding: 24px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.consent-item:hover {
  border-color: #667eea;
  background: #fff;
}

.consent-item-header h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.consent-description {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.consent-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  padding: 12px;
  background: white;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.consent-checkbox:hover {
  background: #f8f9fa;
}

.consent-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-top: 2px;
  flex-shrink: 0;
}

.consent-checkbox span {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}

.continue-button {
  padding: 16px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.continue-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.continue-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  padding: 12px;
  background: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 8px;
  color: #e74c3c;
  font-size: 14px;
  text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/components/onboarding/ConsentForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".consent-form {\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.consent-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.consent-header h2 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.consent-header p {\n  color: #666;\n  font-size: 15px;\n  margin: 0;\n}\n\n.consent-form-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.consent-item {\n  padding: 24px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.consent-item:hover {\n  border-color: #667eea;\n  background: #fff;\n}\n\n.consent-item-header h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.consent-description {\n  color: #666;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n}\n\n.consent-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n  padding: 12px;\n  background: white;\n  border-radius: 8px;\n  transition: background 0.3s ease;\n}\n\n.consent-checkbox:hover {\n  background: #f8f9fa;\n}\n\n.consent-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.consent-checkbox span {\n  color: #333;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 500;\n}\n\n.continue-button {\n  padding: 16px 32px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.continue-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.continue-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error-message {\n  padding: 12px;\n  background: #fff5f5;\n  border: 1px solid #feb2b2;\n  border-radius: 8px;\n  color: #e74c3c;\n  font-size: 14px;\n  text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
